/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetOrganizationPaymentAddonUserOptionResponseDataAddonUserOptionFromJSON, GetOrganizationPaymentAddonUserOptionResponseDataAddonUserOptionToJSON } from './GetOrganizationPaymentAddonUserOptionResponseDataAddonUserOption';
export function GetOrganizationPaymentAddonUserOptionResponseDataFromJSON(json) {
    return GetOrganizationPaymentAddonUserOptionResponseDataFromJSONTyped(json, false);
}
export function GetOrganizationPaymentAddonUserOptionResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        addonUserOption: GetOrganizationPaymentAddonUserOptionResponseDataAddonUserOptionFromJSON(json['addon_user_option'])
    };
}
export function GetOrganizationPaymentAddonUserOptionResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        addon_user_option: GetOrganizationPaymentAddonUserOptionResponseDataAddonUserOptionToJSON(value.addonUserOption)
    };
}
